import React from "react";
import { formatRupiah } from "component/utils/formatRupiah";

const JurnalFormHeader = ({ formData, onChange, isViewMode }) => {
  return (
    <form>
      <div className="row mb-1 align-items-center">
        <label className="col-sm-2 col-form-label">Doc No</label>
        <div className="col-sm-6">
          <input
            type="text"
            className="form-control form-control-sm"
            value={formData.doc_no || ""}
            onChange={(e) => onChange("doc_no", e.target.value)}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-1 align-items-center">
        <label className="col-sm-2 col-form-label">Amount</label>
        <div className="col-sm-6">
          <input
            type="text"
            className="form-control form-control-sm"
            value={formatRupiah(formData.amount_voucher)}
            onChange={(e) => {
              const raw = e.target.value.replace(/[^0-9]/g, ""); // ambil hanya angka
              onChange("amount_voucher", parseInt(raw || "0", 10));
            }}
            disabled={isViewMode}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-1 align-items-center">
        <label className="col-sm-2 col-form-label">Diajukan oleh</label>
        <div className="col-sm-6">
          <input
            type="text"
            className="form-control form-control-sm"
            value={formData.dibuat_oleh || ""}
            onChange={(e) => onChange("dibuat_oleh", e.target.value)}
            disabled={isViewMode}
          />
        </div>
      </div>

      <div className="row mb-1 align-items-center">
        <label className="col-sm-2 col-form-label">Disetujui oleh</label>
        <div className="col-sm-6">
          <input
            type="text"
            className="form-control form-control-sm"
            value={formData.disetujui_oleh || ""}
            onChange={(e) => onChange("disetujui_oleh", e.target.value)}
            disabled={isViewMode}
          />
        </div>
      </div>

      <div className="row mb-1 align-items-center">
        <label className="col-sm-2 col-form-label">Keterangan</label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control form-control-sm"
            value={formData.ket || ""}
            onChange={(e) => onChange("ket", e.target.value)}
            disabled={isViewMode}
          />
          {/* <textarea
            className="form-control form-control-sm"
            value={formData.ket || ""}
            onChange={(e) => onChange("ket", e.target.value)}
            rows={2}
            disabled={isViewMode}
          ></textarea> */}
        </div>
      </div>
    </form>
  );
};

export default JurnalFormHeader;
